import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["apiKey"]

  selectAuthScheme(event) {
    const buttonOrSpanAuthentication = event.currentTarget

    const closestLi = buttonOrSpanAuthentication.closest("li")
    const previousSelected = this.element.querySelector("[aria-selected]")
    if (previousSelected) {
      previousSelected.removeAttribute("aria-selected")
      previousSelected.querySelector("[data-selected-scheme]").dataset.selectedScheme = false
    }
    closestLi.setAttribute("aria-selected", "true")

    buttonOrSpanAuthentication.dataset.selectedScheme = true

    this.dispatch("updatedAuthScheme", { detail: { apiKey: this.apiKeyTarget?.value || "" } })
  }
}
